import { SearchParams } from 'shared/generated-models';

export const getFiltersText = (values: SearchParams) => {
	const cleanParams: Record<string, any> = Object.entries(values)
		.filter(([_, v]) => (Array.isArray(v) ? v.length > 0 : v != null))
		.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

	let result = [];

	if ('text' in cleanParams) result.push(cleanParams['text'].trim());
	if ('skills' in cleanParams) result.push(cleanParams['skills'].map((s: string) => s.trim()).join(', '));
	if ('required_skills' in cleanParams)
		result.push(cleanParams['required_skills'].map((s: string) => s.trim()).join(', '));
	if ('bonus_skills' in cleanParams) result.push(cleanParams['bonus_skills'].map((s: string) => s.trim()).join(', '));
	if ('prog_langs' in cleanParams) result.push(cleanParams['prog_langs'].map((s: string) => s.trim()).join(', '));
	if ('so_skills' in cleanParams) result.push(cleanParams['so_skills'].map((s: string) => s.trim()).join(', '));
	if ('github_repos' in cleanParams) result.push(cleanParams['github_repos'].map((s: string) => s.trim()).join(', '));
	if ('job_titles' in cleanParams) result.push(cleanParams['job_titles'].map((s: string) => s.trim()).join(', '));
	if ('yo_employment' in cleanParams)
		result.push(cleanParams['yo_employment'].map((s: string) => s.trim()).join(', '));
	if ('yo_experience' in cleanParams)
		result.push(cleanParams['yo_experience'].map((s: string) => s.trim()).join(', '));
	if ('seniority' in cleanParams) result.push(cleanParams['seniority'].map((s: string) => s.trim()).join(', '));
	if ('locations' in cleanParams) result.push(cleanParams['locations'].map((s: string) => s.trim()).join(', '));
	if ('countries' in cleanParams) result.push(cleanParams['countries'].map((s: string) => s.trim()).join(', '));
	if ('sub_regions' in cleanParams) result.push(cleanParams['sub_regions'].map((s: string) => s.trim()).join(', '));
	if ('regions' in cleanParams) result.push(cleanParams['regions'].map((s: string) => s.trim()).join(', '));
	if ('schools' in cleanParams) result.push(cleanParams['schools'].map((s: string) => s.trim()).join(', '));
	if ('is_top_school' in cleanParams) result.push('Top School');
	if ('is_first_name_female' in cleanParams) result.push('First name female');
	if ('likely_to_move_prob' in cleanParams) result.push('Likely to move');
	if ('languages' in cleanParams) result.push(cleanParams['languages'].map((s: string) => s.trim()).join(', '));
	if ('companies' in cleanParams) result.push(cleanParams['companies'].map((s: string) => s.trim()).join(', '));
	if ('companies_to_exclude' in cleanParams)
		result.push(cleanParams['companies_to_exclude'].map((s: string) => s.trim()).join(', '));
	if ('current_job_title' in cleanParams)
		result.push(cleanParams['current_job_title'].map((s: string) => s.trim()).join(', '));
	if ('publications' in cleanParams) result.push(cleanParams['publications'].map((s: string) => s.trim()).join(', '));
	if ('awards' in cleanParams) result.push(cleanParams['awards'].map((s: string) => s.trim()).join(', '));
	if ('certifications' in cleanParams)
		result.push(cleanParams['certifications'].map((s: string) => s.trim()).join(', '));
	if ('patents' in cleanParams) result.push(cleanParams['patents'].map((s: string) => s.trim()).join(', '));

	return result.join(', ');
};
